import React from "react";
import { useForm } from "react-final-form";

export interface Options {
    value: string | number;
    label: React.ReactNode;
}

export interface CheckboxProps extends React.HTMLAttributes<HTMLInputElement> {
    id?: string;
    disabled?: boolean;
    className?: string;
    required?: boolean;
    groupClassName?: string;
    labelClassName?: string;
    fields?: any;
    name: string;
    options: Array<Options>;
    // onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const Checkbox: React.FC<CheckboxProps> = ({ groupClassName, labelClassName, options, onChange, fields, id, ...props }) => {
    const form = useForm();
    /* @ts-ignore */
    const toggle = (event: React.ChangeEvent<HTMLInputElement>) => {
        form.change(props.name, event.target.checked);
        /* @ts-ignore */
        props.onChange && props.onChange(event);
    };

    return (
        <React.Fragment>
            {options.map((option) => {
                const newId = id ?? `${props.name}_${option.value}`;
                const checked = fields?.value !== undefined && fields.value.includes(option.value);
                return (
                    <div className={groupClassName} key={option.value}>
                        <input
                            type="checkbox"
                            onChange={(event) => (onChange ? onChange(event) : toggle(event))}
                            checked={checked}
                            value={option.value}
                            {...props}
                            id={newId}
                        />
                        <label className={labelClassName} htmlFor={newId}>
                            {option.label}
                        </label>
                        {/* {checked && <i className="icon-check"></i>} */}
                    </div>
                );
            })}
        </React.Fragment>
    );
};

Checkbox.defaultProps = {
    className: "field-control-checkbox__input",
    groupClassName: "field-control-checkbox__group",
    labelClassName: "field-control-checkbox__label",
};

export default Checkbox;
